import React, { Component } from 'react';
import { Card, Button, Divider, Modal } from 'antd';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { Link } from 'react-router';
import { injectIntl, FormattedMessage } from 'react-intl';
import { themeColors } from '../../../constants/themes';
import { theme } from '../../../constants';
import IconSvg from '../../common/IconSvg';
import AddOnsCheckboxes from './AddOnsCheckboxes';
import { RowFlex } from '../../common/FlexStyle';
import Dropdown from '../../common/Dropdown';
import { SelectLabel } from './styled';
// import Checkout from '../../Checkout';
import eNums from '../../../constants/enums';

const { Option } = Dropdown;

const CustomCard = styled(Card)`
  margin: 0 5px;
  border-radius: 8px;
  border: ${props => (props.selected ? `1px solid ${themeColors.darkBlue}` : '')};
  box-shadow: 0 1px 6px 0 rgba(71, 69, 136, 0.11);
  ${({ zindex }) => zindex && 'z-index: 1;'}
  :hover {
    box-shadow: 0 1px 6px 0 rgba(71, 69, 136, 0.11);
  }
  & .ant-card-body {
    padding: 15px 10px;
    position: relative;
  }
  ${({ popped, clickedplanbcr }) =>
    popped &&
    `
    transition: all 0.25s ease-out;
    position: absolute;
    top: 10em;
    left: calc(50% - 140px);
    width: 280px;
    transform: scale(1.2);
    opacity: 1;
    ${clickedplanbcr
      ? `
      &.tm-plan-initial-pos {
        top: ${clickedplanbcr.top}px;
        left: ${clickedplanbcr.left}px;
        width: ${clickedplanbcr.width}px;
        height: ${clickedplanbcr.height}px;
        transform: scale(1);
        opacity: 0.3;
      }
    `
      : ''
    }
  `}
`;
const CloseButtonContainer = styled.div`
  width: 100%;
  position: relative;
  & > span {
    position: absolute;
    right: 0;
    top: 0;
  }
`;

const Row = styled.div`
  margin-top: ${({ marginTop }) => marginTop && 'auto'};
  display: flex;
  justify-content: center;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AdditionalInfoWrapper = styled.div`
  padding: 5px 0;
  font-size: ${theme.fontSize.medium};
`;

// const RequiredFields = styled.div`
//   display: flex;
//   flex-direction: column;
//   margin: 10px 0 0 10px;
//   font-size: ${theme.fontSize.small};
// `;

const FlexibleInfoWrapper = ({ children }) => (
  <div
    css={css`
      height: 330px;
      display: flex;
      flex-direction: column;
      min-height: 0;
    `}
  >
    <div
      css={css`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
      `}
    >
      {children}
    </div>
  </div>
);

const PaypalButton = ({ plan, poppedCardAddOns, upgradePlan }) => {
  // const hastBasicAddon=poppedCardAddOns.filter(addon => addon.isSelected === true)[0].id === "bluecare_plan_1000";
  return (
    <PayPalScriptProvider
      css={css`margin-bottom:10px;`}
      options={{"client-id":`${process.env.REACT_APP_PAYPAL_CLIENT_ID}`}}
    >
      <PayPalButtons
        fundingSource='paypal'
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  // eslint-disable-next-line no-nested-ternary
                  value: (plan.monthlyCost + poppedCardAddOns.filter(addon => addon.isSelected === true)[0].cost).toFixed(2)
                },
              }
            ]
          })
        }}
        onApprove={(data, actions) => {
          return actions.order.capture().then((details) => {
            upgradePlan(plan.id, poppedCardAddOns, details.id)
              .then(() => {
                // if (resp) {
                //   checkUserHasCourse();
                //   toggleAddOn(true, "course");
                //   this.setState({ wasPurchaseSuccess: true });
                // } else {
                //   this.setState({ wasPurchaseSuccess: true });
                //   toggleAddOn(false, "course");
                // }
              })
              .catch((err) => console.log("subscription error: ", err));
          })
        }}
      />
    </PayPalScriptProvider>
  )
}

const { confirm } = Modal;

@inject('settingsStore')
@injectIntl
@observer
class SubscriptionPlanCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poppedCardAddOns:
        props.settingsStore.subscription
          .planById(props.plan.id)
          .allowedAddOnPlans // .reduce((acc, curr)=>!curr.isSelected ? [...acc, curr] : acc, [])
          .filter(x => x.id !== 'course')
          .map(({ id, cost, plans, name, typeId }) => {
            const isSelected = id.includes('plus');
            return {
              id,
              isSelected,
              cost,
              plans,
              name,
              typeId,
            };
          }) || [],
      paymentMethod: '',
    };
    this.toggleAddOn = this.toggleAddOn.bind(this);
  }

  showDowngradeInfo(planId) {
    const { upgradePlan, intl } = this.props;
    confirm({
      content: intl.formatMessage({ id: 'subscription.downgradeInfo' }),
      onOk() {
        upgradePlan(planId, []);
      },
      onCancel() { },
    });
  }

  toggleAddOn(newValue, addOnId) {
    const { poppedCardAddOns } = this.state;
    const {
      settingsStore: {
        subscription: { addOnById },
      },
    } = this.props;
    const thisAddOnCategory = addOnById(addOnId);
    const newState =
      newValue === true
        ? {
          poppedCardAddOns: poppedCardAddOns.map(addOn => {
            return {
              ...addOn,
              // only one addOnPlan from a given type can be active
              isSelected: addOn.id === addOnId ? true : !thisAddOnCategory.hasPlan(addOn.id),
            };
          }),
        }
        : {
          poppedCardAddOns: poppedCardAddOns.map(addOn => {
            return {
              ...addOn,
              isSelected: addOn.id === addOnId ? false : addOn.isSelected,
            };
          }),
        };
    this.setState(newState);
  }

  upgradeSubscriptionWithPayoneer(id, poppedCardAddOns) {
    const {
      settingsStore: {
        subscription: { setWantUpgrade, setPlanId, setPoppedCardAddOns },
        connectionManagement: { connectPayoneerAccount },
      },
      closeCard,
    } = this.props;
    setWantUpgrade(true);
    setPlanId(id);
    setPoppedCardAddOns(poppedCardAddOns);
    connectPayoneerAccount();
    closeCard();
  }

  upgradeSubscriptionWithStripe(id, poppedCardAddOns) {
    const {
      settingsStore: {
        subscription: {
          setWantUpgradeWithStripe,
          setPlanIdWithStripe,
          setPoppedCardAddOnsWithStripe,
        },
        connectionManagement: { connectStripeAccount },
      },
      closeCard,
    } = this.props;
    setWantUpgradeWithStripe(true);
    setPlanIdWithStripe(id);
    setPoppedCardAddOnsWithStripe(poppedCardAddOns);
    connectStripeAccount();
    closeCard();
  }

  handlePaymentMethodChange = value => {
    this.setState({ paymentMethod: value });
  };

  render() {
    const {
      plan,
      plan: { monthlyCostUnreduced },
      monthlyPayment,
      upgradePlan,
      selected,
      selectedPlanCost,
      poppedOver,
      closeCard = () => { },
      requiredData = [],
      intl,
      hoveringCardButtonMessage,
      isJA,
      disableUpgrade,
      recommendedPlanId,
      openOtherPlanCard,
      clickedPlanBCR,
      htmlID,
      isNonApi,
      noListDescription,
      hoveringCardVisible = false,
      billableAccounts = '',
      currentPlanId,
      settingsStore: {
        subscription: { trialEligible, isFirstPaidSubscription },
      },
    } = this.props;
    const { poppedCardAddOns, paymentMethod } = this.state;

    const needsMoreInfo = requiredData.some(data => !data.value);
    const cost = monthlyPayment ? plan.monthlyCost : plan.annualCost;
    let buttonMessage;
    let actualHtmlID;
    if (!poppedOver) {
      actualHtmlID = htmlID;
      buttonMessage = intl.formatMessage({ id: 'subscription.updatePlan' });
    } else {
      actualHtmlID = 'tm-popped-over-plan-card';
      buttonMessage = hoveringCardButtonMessage;
    }
    if (currentPlanId === eNums.SUBSCRIPTION_PLANS.FREE_TRAIL) {
      buttonMessage = intl.formatMessage({ id: 'subscription.payNow' });
    }

    const requiredOptionSelected = poppedCardAddOns.length
      ? poppedCardAddOns.some(({ isSelected }) => isSelected)
      : true;

    // styles for nonApi and Api plans
    // default colors
    const planStyle = {
      color: '#2E3849',
      limitedColor: '#FF3852',
      badgeBG: '#0070BA',
      badgeSide: '#0070BA',
      buttonBg: 'transparent',
      buttonColor: '#0070BA',
    };
    if (plan.isHighlyRecommended) {
      if (isNonApi) {
        planStyle.backgroundColor = '#00A5F2';
        planStyle.color = '#fff';
        planStyle.limitedColor = '#fff';
        planStyle.listIcon = '/assets/icons/plan_star_light.svg';
        planStyle.badgeBG = '#FFAA2A';
        planStyle.badgeSide = '#D08006';
        planStyle.buttonBg = planStyle.badgeBG;
        planStyle.buttonColor = '#fff';
      } else {
        planStyle.backgroundColor = '#FFA100';
        planStyle.color = '#203A63';
        planStyle.limitedColor = '#fff';
        planStyle.listIcon = '/assets/icons/plan_star_dark.svg';
        planStyle.badgeBG = '#00A5F2';
        planStyle.badgeSide = '#006D9F';
        planStyle.buttonBg = planStyle.badgeBG;
        planStyle.buttonColor = '#fff';
      }
    } else if (isNonApi) {
      planStyle.listIcon = '/assets/icons/plan_star_grey.svg';
    } else {
      planStyle.listIcon = '/assets/icons/plan_star_orange.svg';
    }

    // replace plan id name for nonapi
    const planIcon = plan.id.replace('_nonapi', '');
    // check if we have an icon for it, the array should reflect the svgs used in the project
    // @todo maybe find a way to make this dynamical instead of hardcoding the dictionary?
    const showPlanIcon = [
      'plan_100',
      'plan_250',
      'plan_1000',
      'plan_3000',
      'plan_5000',
      'plan_10000',
    ].includes(planIcon);

    return (
      <div onClick={e => poppedOver && e.stopPropagation()} id={actualHtmlID}>
        <CustomCard
          selected={selected}
          popped={poppedOver ? 1 : 0}
          zindex="1"
          clickedplanbcr={clickedPlanBCR}
          className="tm-plan-initial-pos"
          style={planStyle}
        >
          {poppedOver && (
            <CloseButtonContainer>
              <IconSvg type="x" onClick={closeCard} size={10} />
            </CloseButtonContainer>
          )}
          {!poppedOver && !!plan.includesBIFMCatalog && (
            <RowFlex
              css={css`
                position: absolute;
                top: -11px;
                left: 50%;
                transform: translateX(-50%);
                background: ${planStyle.badgeBG};
                color: #fff;
                width: 60%;
                height: 27px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 0 0 8px 8px;
                visibility: ${plan.isHighlyRecommended ? 'visible' : 'hidden'};
                text-align: center;

                &::before,
                &::after {
                  content: '';
                  display: block;
                  position: absolute;
                  width: 9px;
                  height: 11px;
                  top: 0;
                }

                &::before {
                  left: -9px;
                  background: linear-gradient(
                    to bottom right,
                    transparent 0%,
                    transparent 50%,
                    ${planStyle.badgeSide} 50%,
                    ${planStyle.badgeSide} 100%
                  );
                }

                &::after {
                  right: -9px;
                  background: linear-gradient(
                    to bottom left,
                    transparent 0%,
                    transparent 50%,
                    ${planStyle.badgeSide} 50%,
                    ${planStyle.badgeSide} 100%
                  );
                }

                & > span {
                  font-family: Heebo-Bold;
                  font-size: 14px;
                  margin: 0 5px;
                }
                & > div {
                  background: #fff;
                  width: 14px;
                  height: 14px;
                  line-height: 14px;
                  border-radius: 9px;
                }
              `}
            >
              <span>most popular</span>
            </RowFlex>
          )}
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {showPlanIcon && <IconSvg type={planIcon} size={44} style={{ marginRight: '6px' }} />}
            <span
              style={{ fontSize: '14px', fontFamily: 'Heebo-Bold', textTransform: 'uppercase' }}
            >
              {plan.name}
            </span>
          </div>
          <div style={{ fontFamily: 'Heebo-Bold', textAlign: 'center', lineHeight: '1.4' }}>
            <span style={{ fontSize: '24px' }}>${cost}</span>
            <span style={{ fontSize: '12px', opacity: '50%' }}>
              {' '}
              /{monthlyPayment ? 'mo' : 'year'}
            </span>
          </div>
          <div
            style={{
              fontFamily: 'Heebo-Regular',
              textAlign: 'center',
              fontSize: '14px',
              lineHeight: '1.2',
              color: planStyle.limitedColor,
            }}
          >
            <span>
              {poppedOver && trialEligible ? (
                <></>
              ) : (
                <span>
                  $<del>{monthlyCostUnreduced}</del>&nbsp;{isNonApi ? '30%' : '50%'}{' '}
                </span>
              )}
            </span>
          </div>
          <div
            style={{
              color: `${plan.isHighlyRecommended ? planStyle.limitedColor : 'red'}`,
              fontSize: '11px',
              textAlign: 'center',
              lineHeight: '1.2',
            }}
          >
            *Limited time offer
          </div>
          <Divider style={{ margin: '1em 0' }} />
          <FlexibleInfoWrapper>
            {noListDescription ?? (
              <div
                className="scroll-1"
                css={css`
                  height: 180px;
                  overflow-y: auto;
                  flex-grow: 1;
                  min-height: 0;
                  ul {
                    font-size: ${theme.fontSize.medium};
                    list-style: none;

                    li {
                      display: flex;
                      margin-bottom: 5px;

                      &::before{
                        content:"";
                        display:inline-block;
                        height: 20px;
                        width: 20px;
                        margin-right: 6px;
                        background-image: url('${planStyle.listIcon}');
                        background-size: cover;
                      }
                    }
                  }
                `}
                dangerouslySetInnerHTML={{ __html: plan.description }}
              />
            )}
            {poppedOver && recommendedPlanId && (
              <Link
                onClick={() => {
                  closeCard();
                  openOtherPlanCard(null, recommendedPlanId);
                }}
              >
                <IconSvg type="space-ship" size={20} /> Click here to check out a better plan (with
                BIFM and Catalog included)
              </Link>
            )}
            {/* {poppedOver && !selected && needsMoreInfo && (
              <AdditionalInfoWrapper>
                <span style={{ color: themeColors.pink }}>*</span>
                <FormattedMessage id="subscription.needMoreInfo" />
                <RequiredFields>
                  {requiredData.map(data =>
                    !data.value ? (
                      <span key={data.type}>
                        <FormattedMessage id={`userProfile.${data.type}`} />
                      </span>
                    ) : null,
                  )}
                </RequiredFields>
              </AdditionalInfoWrapper>
            )} */}
            {poppedOver && !selectedPlanCost && !needsMoreInfo && !trialEligible && (
              <AdditionalInfoWrapper>
                <span style={{ color: themeColors.pink }}>*</span>
                <FormattedMessage
                  id="subscription.firstPayment"
                  values={{ monthlyCost: `$ ${plan.monthlyCost}` }}
                />
              </AdditionalInfoWrapper>
            )}
            {poppedOver && !selected && (
              <AdditionalInfoWrapper
                css={css`
                  span {
                    color: ${planStyle.color};
                  }
                `}
              >
                <AddOnsCheckboxes addOns={poppedCardAddOns} toggleAddOn={this.toggleAddOn} planId={plan.id} />
              </AdditionalInfoWrapper>
            )}
            {!selected && !hoveringCardVisible && (
              <Row>
                <Col>
                  <Button
                    id={`btn_${plan.id}`}
                    disabled={disableUpgrade || !requiredOptionSelected}
                    style={{
                      background: planStyle.buttonBg,
                      fontSize: isJA ? '10px' : '14px',
                      borderColor: planStyle.badgeBG,
                      color: planStyle.buttonColor,
                      borderRadius: '12px',
                      fontFamily: 'Heebo',
                    }}
                    onClick={() => upgradePlan(plan.id, poppedCardAddOns)}
                  >
                    {trialEligible ? 'Start with 1$' : buttonMessage}
                  </Button>
                  {trialEligible && (
                    <span
                      css={css`
                        text-align: center;
                        position: relative;
                        top: 5px;
                      `}
                    >
                      7 days trial
                    </span>
                  )}
                </Col>
              </Row>
            )}

            {trialEligible && poppedOver && (
              <span
                css={css`
                  text-align: center;
                `}
              >
                <span style={{ color: themeColors.pink }}>*</span>
                <span> After trial you will pay ${cost - 1} </span>
              </span>
            )}
            {hoveringCardVisible && billableAccounts.length === 0 && (
              <div
                css={css`
                  margin-top: 10px;
                `}
              >
                <Divider
                  css={css`
                    paddin: 0;
                    margin: 0;
                  `}
                />
                <div
                  css={css`
                    margin-top: 10px;
                  `}
                >
                  <SelectLabel>
                    <div
                      css={css`
                        text-align: center;
                        margin-bottom: 10px;
                      `}
                    >
                      Select a payment method
                    </div>
                  </SelectLabel>
                  <span
                    css={css`
                      margin-left: 5px;
                    `}
                  >
                    <Dropdown width="250px" onChange={this.handlePaymentMethodChange}>
                      {
                        isFirstPaidSubscription && plan.maxListedItems <= 10000 && (
                          <Option key="paypal" value="paypal">
                            Paypal
                          </Option>
                        )}
                      <Option key="payoneer" value="payoneer">
                        Payoneer
                      </Option>
                      {/* <Option key="stripe" value="stripe" disabled={isStripeDisabled}>
                        <Tooltip title="Credit card payments are temporarily disabled.">
                          Credit Card
                        </Tooltip>
                      </Option> */}
                    </Dropdown>
                  </span>
                </div>
              </div>
            )}
            {hoveringCardVisible && paymentMethod === 'paypal' && (
              <div css={css`margin-top:15px;`}>
                <PaypalButton plan={plan} poppedCardAddOns={poppedCardAddOns} upgradePlan={upgradePlan} />
              </div>
            )}
            {hoveringCardVisible && billableAccounts.length === 0 && paymentMethod === 'payoneer' && (
              <Button
                id={`btn_${plan.id}`}
                style={{
                  position: 'relative',
                  top: '10px',
                  zIndex: '10',
                  marginTop: '15px',
                }}
                size="large"
                type="secondary"
                onClick={() => this.upgradeSubscriptionWithPayoneer(plan.id, poppedCardAddOns)}
                disabled={false}
              >
                <FormattedMessage id="balance.loadViaPayoneer" />
                <IconSvg type="payoneer" size="20" marginLeft="5px" />
              </Button>
            )}
            {hoveringCardVisible && billableAccounts.length === 0 && paymentMethod === 'stripe' && (
              <Button
                id={`btn_${plan.id}`}
                style={{
                  position: 'relative',
                  marginTop: '20px',
                  top: '10px',
                  zIndex: '10',
                }}
                size="large"
                type="secondary"
                onClick={() => this.upgradeSubscriptionWithStripe(plan.id, poppedCardAddOns)}
                disabled={false}
              >
                <FormattedMessage id="balance.loadViaStripe" />
                <IconSvg type="creditcard" size="30" marginLeft="5px" />
              </Button>
            )}
            {/* {hoveringCardVisible && billableAccounts.length === 0 && paymentMethod === 'paypal' && (
              <Checkout
                afterConnect={() => {
                  upgradePlan(plan.id, poppedCardAddOns);
                }}
                subscriptionStyle="position:relative; bottom:10px;"
              />
            )} */}
            {hoveringCardVisible && billableAccounts.length !== 0 && (
              <Row marginTop>
                <Button
                  id={`btn_agree_${plan.id}`}
                  disabled={disableUpgrade || !requiredOptionSelected}
                  style={{
                    background: planStyle.buttonBg,
                    fontSize: isJA ? '10px' : '14px',
                    borderColor: planStyle.badgeBG,
                    color: planStyle.buttonColor,
                    borderRadius: '12px',
                    fontFamily: 'Heebo',
                  }}
                  onClick={() => upgradePlan(plan.id, poppedCardAddOns)}
                >
                  {buttonMessage}
                </Button>
              </Row>
            )}
            {
              hoveringCardVisible && billableAccounts.length !== 0 && isFirstPaidSubscription && plan.maxListedItems < 10000 && (
                <div>
                  <div css={css`margin-bottom:7px;margin-top:7px;text-align:center;`}>Or you can one time use:</div>
                  <PaypalButton plan={plan} poppedCardAddOns={poppedCardAddOns} upgradePlan={upgradePlan} />
                </div>
              )}
          </FlexibleInfoWrapper>
        </CustomCard>
      </div>
    );
  }
}

SubscriptionPlanCard.propTypes = {
  plan: PropTypes.object,
  intl: PropTypes.object,
  selected: PropTypes.bool,
  upgradePlan: PropTypes.func,
  closeCard: PropTypes.func,
  monthlyPayment: PropTypes.bool,
  isJA: PropTypes.bool,
  poppedOver: PropTypes.bool,
  selectedPlanCost: PropTypes.number,
  requiredData: PropTypes.array,
  settingsStore: PropTypes.object,
  hoveringCardButtonMessage: PropTypes.string,
  recommendedPlanId: PropTypes.string,
  openOtherPlanCard: PropTypes.func,
};

export default SubscriptionPlanCard;
